import { render, staticRenderFns } from "./SectionServices.vue?vue&type=template&id=50fb8aa5&scoped=true&"
import script from "./SectionServices.vue?vue&type=script&lang=js&"
export * from "./SectionServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb8aa5",
  null
  
)

export default component.exports